export class tVerModel {
    id: number;
    versionNo: number;
    revisionNo: number;
    versionName: string;
    createdDate: Date;
    releaseDate: Date;
    revisionHistory: string;
    createdBy: string;
}


export class currentVerInfoID {
    static id = 12;
}